import lodash from 'lodash'
import Base, { criteriaIgnore } from "../base.store";
import request from "../../../../utils/request";

const baseUrl = '/api/v1/ws/ktbs'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        directLinkApprove(context, { data, config }) {
            return base.request.post(`${baseUrl}/direct-link/approve`, data, { ...config });
        },
        directLinkCharge(context, { data, config }) {
            return base.request.post(`${baseUrl}/direct-link/charge`, data, { ...config });
        },
        reportPaymentOutputFiles(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null;
                }
            });
            return request.post(`${baseUrl}/report-payment-output-files`, criteria, { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
